import { render, staticRenderFns } from "./FixedIcon.vue?vue&type=template&id=72320272"
import script from "./FixedIcon.vue?vue&type=script&lang=js"
export * from "./FixedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports